import ColorByStatus from './ColorByStatus'
import { GridActionsCellItem } from 'vendor/x-data-grid'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function GridUnbalanceObservado({ red }) {
  if (red) {
    return [
      <GridActionsCellItem
        icon={<FontAwesomeIcon icon={faEye} size={'1x'} fixedWidth />}
        label=""
        color="primary"
      />,
    ]
  } else {
    return null
  }
}

export default GridUnbalanceObservado
